/**
 * Created by hp on 2017/5/25.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import {Dialog, Grids, LoadMore} from 'react-weui';

class ClassroomCheckInDialog extends Component {
    constructor(props) {
        super(props);
        this.onScrollHandle = this.onScrollHandle.bind(this);
    }

    state = {
        styles: {
            buttons: [
                {
                    type: 'primary',
                    label: '确定',
                    onClick: this.onHideDialog.bind(this)
                }
            ]
        }
    };

    onHideDialog() {
        this.props.dispatch({
            type: 'HIDE_CHECK_IN_DIALOG'
        })
    }

    onScrollHandle(e) {
        let {lecture, message, checkInObject} = this.props;

        let topOffset = e.target.scrollTop;
        let containerHeight = e.target.clientHeight;
        let allHeight = e.target.scrollHeight;
        if (allHeight - containerHeight - topOffset === 0 && checkInObject.hasMore) {
            let listUrl = `/api/classroom/${lecture.id}/checkin/${message.meta.check_in_id}/record?offset=${checkInObject.nextOffset}`;
            axios.get(listUrl).then((res) => {
                let userList = res.data.data.records.map((item) => {
                    let newCheckIn = {
                        icon: <img src={item.account.small_avatar_url} alt="headimg"/>,
                        label: item.account.nickname
                    };
                    return newCheckIn;
                });
                this.props.dispatch({
                    type: 'SET_CHECK_IN_OBJECT',
                    preload: {
                        userList: [...checkInObject.userList, ...userList],
                        nextOffset: res.data.data.next_offset,
                        hasMore: res.data.data.has_more
                    }
                });
            });
        }
    }

    render() {
        let {styles} = this.state;
        let {showCheckInDialog, checkInHead, checkInObject} = this.props;
        if (!showCheckInDialog) {
            return null;
        }

        return (
            <div id="check-in-users-dialog" className="check-in-users-dialog" onScroll={this.onScrollHandle}>
                <Dialog buttons={styles.buttons} show={showCheckInDialog} title={checkInHead}>
                    <Grids data={checkInObject.userList}/>
                    {checkInObject.hasMore &&
                    <div style={{paddingBottom: '1.5em'}}>
                        <LoadMore loading>Loading</LoadMore>
                    </div>
                    }
                </Dialog>
            </div>
        )
    }
}

export default connect((state) => ({
    message: state.checkin.checkInMessage,
    checkInHead: state.checkin.checkInHead,
    checkInObject: state.checkin.checkInObject,
    showCheckInDialog: state.checkin.showCheckInDialog,
    lecture: state.classroom.lecture,
}))(ClassroomCheckInDialog)


// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomCheckInDialog.js